import {
  Box,
  Button,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const OpenSidebarButton = styled(Button)`
  margin-right: ${({ theme }) => getThemeSpacing(3, theme)};
  display: flex;
  @media (min-width: 1199px) {
    display: none;
  }
`

export const SideBox = styled(Box)`
  @media (max-width: 768px) {
    order: 1;
    min-width: auto;
  }
`

export const PopoverText = styled(Box)`
  background: ${({ theme }) => getThemeColor('secondary', theme) + 22};
  cursor: pointer;
`
